/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 11:42:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-27 11:02:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/components/SelectPaymentGatewayModal/index.tsx
 */
import React, { useState } from 'react';
import _ from 'lodash';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import CheckItem from '@/src/components/CheckItem/CheckItem';
import Row from '@/src/components/Layouts/Row/Row';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  handleCloseModal;
  options;
  notFoundContent;
  onConfirm;
  isEdit?;
  defaultValue?;
  defaultCheck?;
  methodList?;
}
const SelectPaymentGatewayModal = ({
  handleCloseModal,
  options,
  notFoundContent,
  onConfirm,
  isEdit,
  defaultValue,
  defaultCheck,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [value, setValue] = useState(isEdit && defaultValue);
  const [check, setCheck] = useState(isEdit ? defaultCheck : []);
  const onChange = (value) => {
    setValue(value);
  };
  const handleSetCheck = (value) => {
    const checkCopy = _.cloneDeep(check);
    if (check.includes(value)) {
      const index = checkCopy.indexOf(value);
      checkCopy.splice(index, 1);
      setCheck(checkCopy);
    } else {
      checkCopy.push(value);
      setCheck(checkCopy);
    }
  };
  const methodList = (
    (value || ({} as any)).salesChannelPaymentMethods || []
  ).map((item) => ({
    name: item.paymentMethodVO.name,
    key: item.paymentMethodVO.paymentMethodCode,
  }));

  return (
    <div>
      <div className={css.selectPaymentGateway}>
        <SelectObjectAsValue
          className={css.select}
          showSearch
          objectAsValue
          size='large'
          value={value}
          getPopupContainer={(trigger) => trigger}
          valueKey='paymentGatewayName'
          labelKey='labelText'
          options={options}
          onChange={onChange}
          filterOption={(input, option) =>
            option?.value.toLowerCase().includes(input.toLowerCase())
          }
          notFoundContent={notFoundContent}
        />
      </div>
      {methodList && methodList.length ? (
        <Row
          elements={[
            {
              child: (
                <CheckItem
                  title={getI18n(
                    'salesChannelPayment.index.availablePaymentMethod',
                  )}
                  checkList={methodList}
                  setCheck={(value) => handleSetCheck(value)}
                  check={check}
                />
              ),
            },
          ]}
        />
      ) : (
        ''
      )}
      <ModalFooter
        onOk={() => {
          onConfirm(value, check);
        }}
        hideOkButton={methodList.length ? !value || !check.length : !value}
        onCancel={handleCloseModal}
      />
    </div>
  );
};

export default SelectPaymentGatewayModal;
